export default __webpack_public_path__ + "static/instagram-caa413412c1de3d91babf96ac5511e7a.svg";